import { IDBContentPage } from '@netfront/ekardo-content-library';
import { jwtDecode } from 'jwt-decode';
import { clsx, type ClassValue } from 'clsx';

export const getValidClassNames = (object: { [key: string]: boolean }) => {
  return Object.keys(object)
    .filter((key) => object[key])
    .join(' ');
};

export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}

export const capitalise = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};

type ContentPageWithParent = IDBContentPage & { parentContentPageTitle?: string };
export const getFlattenContentPages = (
  contentPages: IDBContentPage[] | undefined,
  parentContentPageTitle?: string,
): ContentPageWithParent[] => {
  if (!contentPages) return [];

  return contentPages?.reduce((acc, contentPage) => {
    acc.push({ ...contentPage, parentContentPageTitle: parentContentPageTitle });

    if (contentPage.contentPageChildren && contentPage.contentPageChildren.length) {
      acc.push(...getFlattenContentPages(contentPage.contentPageChildren, contentPage.title));
    }

    return acc;
  }, [] as ContentPageWithParent[]);
};

export const ensureAustralianAreaCode = (phoneNumber: string) => {
  let cleanedNumber = phoneNumber.replace(/[^\d+]/g, '');

  if (/^\+61/.test(cleanedNumber)) {
    return cleanedNumber;
  }

  if (/^0[23478]/.test(cleanedNumber)) {
    return cleanedNumber.replace(/^0/, '+61');
  }

  return cleanedNumber;
};

export const getS3KeyFromUrl = (url: string) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.pathname.startsWith('/') ? parsedUrl.pathname.slice(1) : parsedUrl.pathname;
  } catch (error) {
    console.error('Invalid URL:', error);
    return null;
  }
};

export const isTokenExpired = (token: string | undefined) => {
  if (!token) return true;

  const { exp } = jwtDecode(token);
  const now = Date.now() / 1000;
  return Number(exp) < now;
};

export function appendReminder(iso: string, reminderId?: number | string): string {
  const d = new Date(iso);
  const id = Number(reminderId);

  switch (id) {
    case 5699: // 30 mins
      d.setMinutes(d.getMinutes() - 30);
      break;

    case 5700: // 1 day
      d.setDate(d.getDate() - 1);
      break;

    case 5701: // 1 week
      d.setDate(d.getDate() - 7);
      break;
  }

  return d.toISOString();
}

export function pickRandomItems<T>(arr: T[], count = 4): T[] {
  const shuffled = [...arr].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
}